import { useCallback } from "react";
import { useMessage } from "./useMessage";

const zonesToReuse: eXpress.collections.Dictionary<string, eXpress.core.ITransformableZone[]> =
	new eXpress.collections.Dictionary<string, eXpress.core.ITransformableZone[]>();

export function useReuseZonesForTemplates() {
	const getAndSetReuseZones = useCallback(
		(
			page: eXpress.core.IPageZone | undefined,
		): eXpress.core.ITransformableZone[] | undefined => {
			if (!page || !page.spread) {
				return undefined;
			}

			// Remember the starting PageZone user content (text and photos)
			let zonesToReuseForSpread: eXpress.core.ITransformableZone[] | undefined;
			const spreadKey = page.spread.index.toString() + (page.isLeftPage ? "L" : "R");
			zonesToReuseForSpread = zonesToReuse.get(spreadKey);

			if (!zonesToReuseForSpread) {
				zonesToReuseForSpread = page.getAllZones();
				zonesToReuse.add(spreadKey, zonesToReuseForSpread);

				return undefined;
			}

			return zonesToReuseForSpread;
		},
		[],
	);

	useMessage((message) => {
		// If another command is executed, don't reuse zonesToReuse for addTemplateToPage Command
		if (
			!(message instanceof eXpress.core.TemplateAppliedOnPagesMessage) &&
			eXpress.core.isCommandMessage(message)
		) {
			zonesToReuse.clear();
		}
	});

	return [getAndSetReuseZones] as const;
}
